export default __webpack_public_path__ + "static/media/ico-rds-circle.8d67dc28.svg";